module.exports = __webpack_public_path__ + "img/2.d4fbbd5a.png";